import { paths } from '../../../settings';
import styles from './LoadingSpinner.module.css';

const LoadingSpinner: React.FC = (): JSX.Element => {
    return (
        <div className={styles.wrapper}>
            <img src={`${paths.assets}/icons/loading.png`} width={100} height={100} alt="Ładowanie..." className={styles.spinner} />
        </div>
    );
};

export default LoadingSpinner;